import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "debugging-a-script"
    }}>{`Debugging a Script`}</h1>
    <p>{`This page goes over how to debug common problems you may run into.`}</p>
    <p>{`Quick tips for logs:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The UXP logs and `}<inlineCode parentName="p">{`console.log`}</inlineCode>{` from scripts get written to the following locations `}<br></br>{`
For the InDesign versions below 19.2 -  `}<br></br></p>
        <ul parentName="li">
          <li parentName="ul">{`macOS: `}<inlineCode parentName="li">{`/Users/<user name>/Library/Caches/UXPLogs/`}</inlineCode>{` `}<br></br></li>
          <li parentName="ul">{`Windows: `}<inlineCode parentName="li">{`C:\\Users\\<username>\\AppData\\Local\\Temp\\UXPLogs`}</inlineCode>{` `}<br></br></li>
        </ul>
        <p parentName="li">{`From InDesign 19.2 version onwards log paths have changed as below - `}<br></br></p>
        <ul parentName="li">
          <li parentName="ul">{`Adobe InDesign - `}<br></br>{`
macOS: `}<inlineCode parentName="li">{`/Users/<user name>/Library/Logs/Adobe/Adobe InDesign <InDesign version year>/`}</inlineCode>{` `}<br></br>{`
Windows: `}<inlineCode parentName="li">{`C:\\Users\\<username>\\AppData\\Roaming\\Adobe\\InDesign\\Logs`}</inlineCode>{` `}<br></br></li>
          <li parentName="ul">{`Adobe InDesign Server - `}<br></br>{`
macOS: `}<inlineCode parentName="li">{`/Users/<user name>/Library/Logs/Adobe/Adobe InDesign Server <InDesign version year>/`}</inlineCode>{` `}<br></br>{`
Windows: `}<inlineCode parentName="li">{`C:\\Users\\<username>\\AppData\\Roaming\\Adobe\\InDesign Server\\Logs`}</inlineCode>{` `}<br></br></li>
        </ul>
        <p parentName="li">{`If you find multiple files in the location, pick the one with the latest timestamp.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`All the sample scripts have a try/catch block. Any exceptions raised from the InDesign side will be caught and dumped to the console or displayed on the dialog box.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Interpreter parsing errors go directly to the UXP logs.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "debugging-script-files-using-udt"
    }}>{`Debugging Script files using UDT`}</h2>
    <p>{`Script files are executed in the same context as UXP plugins. Using `}<a parentName="p" {...{
        "href": "https://creativecloud.adobe.com/apps/download/uxp-developer-tools"
      }}>{`UXP Developer Tool`}</a>{` (UDT) v1.7.0, you can step through and debug a script.`}</p>
    <p>{`You can debug script files in UDT by clicking on "Connected Apps", choosing InDesign, and then adding your script from there:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "61.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/5530d/step1.webp 320w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/0c8fb/step1.webp 640w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/94b1e/step1.webp 1280w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/0b34d/step1.webp 1920w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/d5269/step1.webp 2560w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/cb3df/step1.webp 4434w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/dd4a7/step1.png 320w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/0f09e/step1.png 640w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/bbbf7/step1.png 1280w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/ac7a9/step1.png 1920w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/c7a69/step1.png 2560w", "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/09be0/step1.png 4434w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/3b90d9e8891b70e98be4aa00e767cdcb/bbbf7/step1.png",
            "alt": "step 1 of loading an InDesign script into UDT",
            "title": "step 1 of loading an InDesign script into UDT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "61.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/5530d/step2.webp 320w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/0c8fb/step2.webp 640w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/94b1e/step2.webp 1280w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/0b34d/step2.webp 1920w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/d5269/step2.webp 2560w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/cb3df/step2.webp 4434w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/dd4a7/step2.png 320w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/0f09e/step2.png 640w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/bbbf7/step2.png 1280w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/ac7a9/step2.png 1920w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/c7a69/step2.png 2560w", "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/09be0/step2.png 4434w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/358bb18d30076b7661726cd6914e936e/bbbf7/step2.png",
            "alt": "step 2 of loading an InDesign script into UDT",
            "title": "step 2 of loading an InDesign script into UDT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Once you've loaded a script in, you can debug with a breakpoint activated. From here you set breakpoints or Step Into the script files. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      